import { FC, ReactElement } from 'react'
import formatNumber from '@/utils/format-number'
import useExchangeRate from '@/utils/hooks/useExchangeRate'
import { NETWORK } from '@/utils/constants'
import useRoundedSatoshiPrice from '@/utils/hooks/useRoundedSatoshiPrice'
import BaseItem from './base-item'

const DelistItem: FC<{
	onSelect: () => void
	selected: boolean
	slug: string,
	price: number
	data: any
}> = (props): ReactElement => {
	const { data, onSelect, selected, price, slug } = props
	const amount = parseFloat(data.amount)
	const { exchangeRate } = useExchangeRate()
	const roundedSats = useRoundedSatoshiPrice(price * amount, 1e6)
	const usd = formatNumber((((price * amount) / 1e8) * exchangeRate).toFixed(2))

	return (
		<BaseItem data={data} onSelect={onSelect} selected={selected} slug={slug}>
			<span className="shrink-0 text-[10px] font-medium px-2 py-1 rounded bg-gradient-to-r from-purple-600 to-blue-500 text-white select-none">
				Listed
			</span>
			<p className="text-xxs text-muted-foreground">
				{roundedSats} {NETWORK} / ${usd}
			</p>
		</BaseItem>
	)
}

export default DelistItem
